import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_partyIdAdapter2v7zx778kk10s as get_partyIdAdapter,
  get_playerIdAdapter2h87xjwribaa as get_playerIdAdapter,
} from '../../../adapter/Adapter.mjs';
import {
  get_StringAdapter1plpsgiy8rwhj as get_StringAdapter,
  get_NullableStringAdapter3fffxc67fmluc as get_NullableStringAdapter,
  presentmhd0a0ip21um as present,
  list2lpjhmv1d2k19 as list,
} from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Badge_ResponseAdapter_instance9mu49fvvgdlz as Badge_ResponseAdapter_instance } from './Badge_ResponseAdapter.mjs';
import { Present1shu3953j96zb as Present } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { SavePlayerInput3s7vno6nbe1ix as SavePlayerInput } from '../SavePlayerInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SavePlayerInput_InputAdapterClass;
function SavePlayerInput_InputAdapter() {
  if (SavePlayerInput_InputAdapterClass === VOID) {
    class $ {
      e40(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      x6r(writer, customScalarAdapters, value) {
        writer.h48('partyId');
        get_partyIdAdapter().f40(writer, customScalarAdapters, value.n6q_1);
        writer.h48('playerId');
        get_playerIdAdapter().f40(writer, customScalarAdapters, value.o6q_1);
        writer.h48('name');
        get_StringAdapter().f40(writer, customScalarAdapters, value.p6q_1);
        writer.h48('email');
        get_StringAdapter().f40(writer, customScalarAdapters, value.q6q_1);
        writer.h48('badge');
        Badge_ResponseAdapter_instance.z6l(writer, customScalarAdapters, value.r6q_1);
        writer.h48('callSignAdjective');
        get_StringAdapter().f40(writer, customScalarAdapters, value.s6q_1);
        writer.h48('callSignNoun');
        get_StringAdapter().f40(writer, customScalarAdapters, value.t6q_1);
        var tmp = value.u6q_1;
        if (tmp instanceof Present()) {
          writer.h48('imageURL');
          present(get_NullableStringAdapter()).o41(writer, customScalarAdapters, value.u6q_1);
        }
        var tmp_0 = value.v6q_1;
        if (tmp_0 instanceof Present()) {
          writer.h48('avatarType');
          present(get_NullableStringAdapter()).o41(writer, customScalarAdapters, value.v6q_1);
        }
        writer.h48('unvalidatedEmails');
        list(get_StringAdapter()).m41(writer, customScalarAdapters, value.w6q_1);
      }
      f40(writer, customScalarAdapters, value) {
        return this.x6r(writer, customScalarAdapters, value instanceof SavePlayerInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'SavePlayerInput_InputAdapter', VOID, VOID, [Adapter()]);
    SavePlayerInput_InputAdapterClass = $;
  }
  return SavePlayerInput_InputAdapterClass;
}
var SavePlayerInput_InputAdapter_instance;
function SavePlayerInput_InputAdapter_getInstance() {
  return SavePlayerInput_InputAdapter_instance;
}
//region block: init
SavePlayerInput_InputAdapter_instance = new (SavePlayerInput_InputAdapter())();
//endregion
//region block: exports
export {
  SavePlayerInput_InputAdapter_instance as SavePlayerInput_InputAdapter_instance3cegmft9cv7tf,
};
//endregion

//# sourceMappingURL=SavePlayerInput_InputAdapter.mjs.map
